"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getWebpackPublicPathPathname = () => {
    const url = new URL(__webpack_public_path__, window.location.origin);
    return url.pathname;
};
const trimSlashes = (input) => {
    return input.replace(/^\/|\/$/g, '');
};
function normalizePublicPath(unsanitizedVersion, src) {
    const version = unsanitizedVersion ? trimSlashes(unsanitizedVersion) : '';
    const pathname = trimSlashes(getWebpackPublicPathPathname());
    const baseUrl = trimSlashes(new URL(src).origin);
    const isPathnameIncludesVersion = version
        ? pathname.includes(version)
        : false;
    const publicPath = `${baseUrl}/${pathname ? `${pathname}/` : ''}${version && !isPathnameIncludesVersion ? `${version}/` : ''}`;
    return publicPath;
}
const runtimePlugin = () => {
    return {
        name: 'normalizePublicPathPlugin',
        beforeInit(params) {
            const currentScript = document.currentScript;
            const version = process.env.FEDERATED_REMOTE_VERSION;
            if (currentScript?.src) {
                __webpack_public_path__ = normalizePublicPath(version, currentScript.src);
            }
            return params;
        },
    };
};
exports.default = runtimePlugin;
//# sourceMappingURL=normalizePublicPath.js.map